var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDiscord = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.566 5.873c-.401 0-.718.35-.718.777 0 .427.324.777.718.777.401 0 .718-.35.718-.777.007-.427-.317-.777-.718-.777Zm2.57 0c-.402 0-.718.35-.718.777 0 .427.323.777.718.777.4 0 .718-.35.718-.777 0-.427-.317-.777-.718-.777Z",
    fill: "#9999AC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.557 0H2.123C1.328 0 .68.644.68 1.442v9.464c0 .798.648 1.442 1.443 1.442h7.984l-.373-1.295.9.833.853.784L13 14V1.442C13 .644 12.352 0 11.557 0ZM8.839 9.142s-.253-.301-.464-.567c.922-.26 1.274-.833 1.274-.833a4.038 4.038 0 0 1-.81.413c-.352.147-.69.245-1.02.3a4.96 4.96 0 0 1-1.824-.006 5.935 5.935 0 0 1-1.035-.301 4.138 4.138 0 0 1-.514-.238c-.02-.014-.042-.021-.063-.035-.014-.007-.021-.014-.028-.021-.127-.07-.197-.12-.197-.12s.338.56 1.232.827c-.211.266-.472.581-.472.581-1.556-.049-2.147-1.064-2.147-1.064 0-2.254 1.014-4.081 1.014-4.081 1.013-.756 1.978-.735 1.978-.735l.07.084c-1.267.364-1.851.917-1.851.917s.155-.084.415-.203c.753-.33 1.352-.42 1.598-.441.042-.007.078-.014.12-.014a5.762 5.762 0 0 1 3.541.658s-.556-.525-1.753-.89l.099-.111s.964-.021 1.978.735c0 0 1.014 1.827 1.014 4.08 0 0-.599 1.016-2.155 1.065Z",
    fill: "#9999AC"
  })));
};
export default SvgDiscord;